import React, {FC, useEffect, useState} from "react"

import authentication from "@irati/auth"

import AdminOnboarding from "../components/AdminOnboarding"
import TermsAndConditions from "./TermsAndConditions"

interface Props {}

const Onboarding: FC<Props> = () => {
  const [showAdminSetup, setShowAdminSetup] = useState<boolean>(false)

  useEffect(() => {
    setShowAdminSetup(authentication.isGlobalAdmin())
  }, [])

  if (showAdminSetup) {
    return <AdminOnboarding onConfirm={() => setShowAdminSetup(false)} />
  }
  return <TermsAndConditions />
}

export default Onboarding
